module.exports = __webpack_public_path__ + "img/bg1.bf0072fe.png";